// 导入组件，组件必须声明 name
import TestEnv from './index.vue'
// 为组件添加 install 方法，用于按需引入
TestEnv.install = function(Vue) {
	Vue.component(TestEnv.name, TestEnv)
}
export default TestEnv



// WEBPACK FOOTER //
// ./src/components/testenv/index.js